import { render, staticRenderFns } from "./GPreviewForm.vue?vue&type=template&id=10d6bdad&scoped=true&"
import script from "./GPreviewForm.vue?vue&type=script&lang=ts&"
export * from "./GPreviewForm.vue?vue&type=script&lang=ts&"
import style0 from "./GPreviewForm.vue?vue&type=style&index=0&id=10d6bdad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6bdad",
  null
  
)

export default component.exports